// Third-party Library
import { useEffect, useState } from "react"
import { batch, useDispatch, useSelector } from "react-redux"
import { Switch } from "antd"

// Constants
import { TEMPLATE } from "../../../v3/constants"

// Components
import { 
    TripChecklistForm,
    TripChecklistHomepage 
} from "./components"

// Redux Actions
import * as REDUX_ACTIONS from "../../../v3/services/redux/actions"

const {
    LANGUAGE_MODE,
    PRETRIP_WORDINGS
} = TEMPLATE.PRETRIP

const TripChecklist = ({ param }) => {
    
    const dispatch = useDispatch()
    
    const plate = param.get("plate")

    const vehicles = useSelector(state => state.containers.v3.vehicles)
    const vehicleStatic = Object.values(vehicles.staticsByID).shift()
    const vehicleState = Object.values(vehicles.stateByID).shift()

    const [ toForm, setToForm ] = useState(false)
    const [ driver, setDriver ] = useState(null)
    
    useEffect(() => {

        if(plate) {
            dispatch(REDUX_ACTIONS.v3_vehicles.get_vehicle_by_plate_request(plate))
            dispatch(REDUX_ACTIONS.v3_vehicles.get_vehicle_state_by_plate_request(plate))
        }
    }, [plate])

    // Check IC Number
    const checkICNumberHDLR = (icNumber) => {
        batch(() => {
            dispatch(REDUX_ACTIONS.v3_drivers.get_all_driver_checklist_request()) 
            dispatch(REDUX_ACTIONS.v3_drivers.get_driver_by_ic_number_request(icNumber, (drv) => {
                setDriver(drv)
                setToForm(true)
            }))
        })
    }

    const [ success, setSuccess ] = useState()
    const [ language, setLanguage ] = useState(LANGUAGE_MODE.MALAY)

    const {
        title,
        subtitle,
        select,
        color
    } = PRETRIP_WORDINGS[language]

    return (
        <>
        <div style={{ backgroundColor: '#000', color: '#fff', lineHeight: '1em', padding: '.8em 1.5em', display: 'flex', justifyContent: 'space-between'}}>
            <div>
                <h3>{title}</h3>
                <h5>{subtitle}</h5>
                
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <h5>{select} :  </h5>
                <Switch
                    checkedChildren={'MY'}
                    unCheckedChildren={'EN'}
                    style={{
                        backgroundColor: color,
                    }}
                    defaultChecked={'MY'}
                    onChange={e => setLanguage(e ? LANGUAGE_MODE.MALAY : LANGUAGE_MODE.ENGLISH)}
                />
            </div>
        </div>
        <div style={{ maxWidth: '30em', margin: '0 auto' }}>
            {
                toForm ?
                    <TripChecklistForm plate={plate} vehicle={{ ...vehicleState, ...vehicleStatic}} driver={driver} setToForm={setToForm} setSuccess={setSuccess} language={language}/>
                    :
                    <TripChecklistHomepage checkICNumberHDLR={checkICNumberHDLR} success={success} wordings={PRETRIP_WORDINGS[language]}/>
            }
        </div>
        </>
    )
}

export default TripChecklist